import React from 'react';
import type { V2Route } from '../units/types';

/** この担当が新UIで作り直した画面の経路。旧 /ads/carousel と同じく組織の enable_carousel_creation で開ける */
const routes: V2Route[] = [
  { path: 'ads/carousel', Component: React.lazy(() => import('./CarouselPage')), guard: { kind: 'feature', feature: 'enable_carousel_creation' } },
];

export default routes;
